// Gets Time in minutes and returns it into a formatted string
export const displayMinutes = (minutes: number): string => {
  if (minutes < 60) return `${minutes}min`

  const hours = Math.trunc(minutes / 60)
  const mins = minutes % 60

  return `${hours}h${("0" + mins).slice(-2)}`
}
